import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  private hiddenClass = "d-none";

  static targets = ["button", "content"];
  static values = {
    buttonCollapsed: String,
    buttonExpanded: String,
    open: Boolean,
  };

  declare readonly buttonTarget: HTMLButtonElement;
  declare readonly contentTargets: HTMLElement[];
  declare buttonCollapsedValue: string;
  declare buttonExpandedValue: string;
  declare openValue: boolean;

  toggle() {
    this.openValue = !this.openValue;
    this.updateButtonAria();
    this.toggleItems();
    this.updateButtonText();
    this.buttonTarget.blur();
    if (!this.openValue) {
      this.scrollToButtonTarget();
    }
  }

  toggleItems() {
    this.contentTargets.forEach((item) => {
      item.classList.remove(this.hiddenClass);
      if (!this.openValue) {
        item.classList.add(this.hiddenClass);
      }
    });

    if (!this.openValue) {
      this.dispatch("collapse", { cancelable: false });
    }
  }

  updateButtonText() {
    this.buttonTarget.textContent = this.openValue
      ? this.buttonExpandedValue
      : this.buttonCollapsedValue;
  }

  updateButtonAria() {
    this.buttonTarget.setAttribute("aria-expanded", `${this.openValue}`);
  }

  scrollToButtonTarget() {
    this.buttonTarget.scrollIntoView({
      block: "end",
    });
  }
}
